

import slide_image_1 from './certifications/c1.jpg'
import slide_image_2 from './certifications/c2.png'
import slide_image_3 from './certifications/c3.png'
import slide_image_4 from './certifications/c4.png'
import slide_image_5 from './certifications/c5.png'
import slide_image_6 from './certifications/c6.png'
import slide_image_7 from './certifications/c7.png'
import slide_image_8 from './certifications/c8.jpg'
import Landing from './landing';
import Pratical from './pratical';
import Pricing from './education';
import Desc from './Task_Description';


import React, { useRef, useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-cards';

// import './styles.css';

// import required modules
import { EffectCards } from 'swiper/modules';

export default function Cert() {
  return (
 
      <div id="slider_app"  className="slider_container">
   <h1 id="tools" className="heading">certifications</h1>
      <Swiper
        effect={'cards'}
        grabCursor={true}
        modules={[EffectCards]}
        className="mySwiper"
      >
        <SwiperSlide><img src={slide_image_1} alt="no image"/></SwiperSlide>
        <SwiperSlide><img src={slide_image_2} alt="no image"/></SwiperSlide>
        <SwiperSlide><img src={slide_image_3} alt="no image"/></SwiperSlide>
        <SwiperSlide><img src={slide_image_4} alt="no image"/></SwiperSlide>
        <SwiperSlide><img src={slide_image_5} alt="no image"/></SwiperSlide>
        <SwiperSlide><img src={slide_image_6} alt="no image"/></SwiperSlide>
        <SwiperSlide><img src={slide_image_7} alt="no image"/></SwiperSlide>
        <SwiperSlide><img src={slide_image_8} alt="no image"/></SwiperSlide>
      </Swiper>
   </div>
  );
}
